import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { IContentTileActionObj, IContentTileIconObj, IContentTileTextObj } from './content_tile_types';
export class ContentTileController {
  private icon: IContentTileIconObj;
  private text: IContentTileTextObj;
  private action: IContentTileActionObj;
  private isOverdue: boolean;
  private isActive: boolean;
  private isShown: boolean = true;
  private backgroundColor: string;
  private navLinkText: string;
  private overdueText: string;
  private isMobile: boolean;
  private isConfigured: boolean;

  constructor(private $state: ng.ui.IStateService) {}

  $onInit(): void {
    this.isActive = this.isActive || true;
    this.isOverdue = this.isOverdue || false;
    this.overdueText = _4.get(this.text, 'overdueText', 'Overdue:');
    this.isMobile = PlatformUtility.isMobile();
    this.isConfigured = !_4.isEmpty(this.text) && !_4.isEmpty(this.icon);
  }

  $onChanges(): void {
    this.isConfigured = !_4.isEmpty(this.text) && !_4.isEmpty(this.icon);
  }

  getIconTheme() {
    return this.isOverdue ? 'red' : _4.get(this.icon, 'theme', 'blue');
  }

  navigateToUrlOrState(action: IContentTileActionObj): void {
    const href = _4.get(action, 'href');
    const state: string = _4.get(action, 'state');
    const params: {} = _4.get(action, 'params');

    if (!_4.isNil(href)) {
      window.location.assign(href as string);
    } else {
      this.$state.go(state, params);
    }
  }

  changeState(): void {
    const action = this.action;

    if (_4.isFunction(action)) {
      _4.result(this, 'action');
    } else {
      this.navigateToUrlOrState(action);
    }
  }

  goToDetails(): void {
    this.navigateToUrlOrState(this.action);
  }

  goToStateOnMobileOnly() {
    if (this.isMobile) {
      this.changeState();
    }
  }
}

export class ContentTileComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-content-tile/src/components/content_tile/content-tile.html';
  public controller: any = ContentTileController;
  public controllerAs: string = '$ctrl';
  public transclude: any = {
    contentSlot: '?contentTileBody'
  };
  public bindings: any = {
    icon: '<?',
    text: '<?',
    isActive: '<?',
    isOverdue: '<?',
    action: '<?',
    isShown: '<?',
    backgroundColor: '<?',
    navLinkText: '<?'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-content-tile/src/components/content_tile/content-tile.ts